module.exports = require("@swa-ui/itinerary/src/TripOriginDestinationDetail/TripOriginDestinationDetail.module.scss");